import { Badge } from "@chakra-ui/react";
import { STATUS_COLOURS, STATUS_LABELS } from "./placingUtils";

const PlacingStatusBadge = ({ status, ...props }) => (
  <Badge colorScheme={STATUS_COLOURS[status] || "gray"} {...props}>
    {status ? String(STATUS_LABELS[status] || status).toUpperCase() : "—"}
  </Badge>
);

export default PlacingStatusBadge;
